<div class="main-layout">
  <div class="menu">
    <ul nz-menu nzMode="inline">
      <div class="brand">AI Recruit</div>
      <li nz-menu-group nzTitle="Menu">
        <ul>
          <!--          <li nz-menu-item nzDisabled>-->
          <!--            <div>-->
          <!--              <span class="menu-icon" nz-icon nzTheme="outline" nzType="dashboard"></span>Dashboard-->
          <!--            </div>-->
          <!--          </li>-->
          <!--          <li nz-menu-item nzMatchRouter routerLink="create-job">-->
          <!--            <div><span class="menu-icon" nz-icon nzTheme="outline" nzType="diff"></span>New Career Posting</div>-->
          <!--          </li>-->
          <li nz-menu-item nzMatchRouter routerLink="company-list">
            <div>
              <span class="menu-icon" nz-icon nzTheme="outline" nzType="apartment"></span>Company
            </div>
          </li>
          <li nz-menu-item nzMatchRouter routerLink="career">
            <div><span class="menu-icon" nz-icon nzTheme="outline" nzType="container"></span>Career</div>
          </li>
          <li nz-menu-item nzMatchRouter routerLink="examination">
            <div>
              <span class="menu-icon" nz-icon nzTheme="outline" nzType="experiment"></span>
              Examination
            </div>
          </li>
          <li nz-menu-item nzMatchRouter routerLink="staff">
            <div>
              <span class="menu-icon" nz-icon nzTheme="outline" nzType="team"></span>
              Staff
            </div>
          </li>
          <!--          <li nz-menu-item nzDisabled>-->
          <!--            <div>-->
          <!--              <span class="menu-icon" nz-icon nzTheme="outline" nzType="user"></span>Candidate-->
          <!--            </div>-->
          <!--          </li>-->
        </ul>
      </li>
    </ul>
    <div class="logout" (click)="onSignOut()">
      <span nz-icon nzTheme="outline" nzType="logout"></span>Sign out
    </div>
  </div>
  <div #content class="main-layout__content" id="content">
    <router-outlet></router-outlet>
  </div>
</div>

<div (click)="onGoToTop()" *ngIf="isVisible" class="back-to-top"><span nz-icon nzTheme="outline" nzType="to-top"></span>
</div>
